export const REGIONAL_MEDICAL_DIRECTOR = 'Regional Medical Director'; // earlier LEAD CLINICIAN
export const REGIONAL_MEDICAL_DIRECTORS = 'Regional Medical Directors';
export const REGIONAL_MEDICAL_DIRECTOR_LOWERCASE = 'regional medical director';
